import ProfileContext from "context/ProfileContext";
import React, { useContext, useState, useEffect, useCallback, useRef } from "react";
import { Spinner, Table } from "react-bootstrap";
import { Search } from "react-bootstrap-icons";
import "./hostlisting.css";
import { Field, Form, Formik } from "formik";
import { ProHostAlllist } from "./HostAlllist";
import PurebrandToast from "components/Toasts/Toast";
import InfiniteScroll from 'react-infinite-scroll-component';

const HostsProSoftList = () => {
  let { updateHostRequestsOnce, updatedHostsOnce, nextAllHosts } =
    useContext(ProfileContext);
  const [loadingPros, setLoadingPros] = useState(false);
  const [searchTerminologyAll, setSearchTerminologyAll] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [failed, setFailed] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const isLoadingRef = useRef(false); // Prevent multiple simultaneous calls

  const handleCloseToast = () => {
    setShowToast(false);
  };

  // Fetch more data for infinite scroll with proper race condition handling
  const fetchMoreData = useCallback(() => {
    // Prevent multiple simultaneous calls using ref
    if (!nextAllHosts || !hasMore || isLoadingRef.current) {
      return;
    }
    
    // Set loading state immediately to prevent race conditions
    isLoadingRef.current = true;
    setLoadingPros(true);
    
    const currentNextUrl = nextAllHosts; // Capture current URL
    
    updateHostRequestsOnce(
      new URL(currentNextUrl).search,
      true // Pass true to append data instead of replacing
    )
    .then((response) => {
      console.log('✅ fetchMoreData success:', response?.data?.data?.results?.length, 'new items');
      setLoadingPros(false);
      isLoadingRef.current = false;
      
      // Check if there's more data using the response
      if (!response?.data?.data?.next) {
        setHasMore(false);
      }
    })
    .catch((error) => {
      setLoadingPros(false);
      isLoadingRef.current = false;
      // Don't set hasMore to false on error, allow retry
    });
  }, [nextAllHosts, hasMore, updateHostRequestsOnce]);

  // Reset hasMore when search changes
  useEffect(() => {
    setHasMore(true);
    isLoadingRef.current = false; // Reset loading ref on search
  }, [searchTerminologyAll]);

  const gethostsAll = () => {
    if (updatedHostsOnce && updatedHostsOnce.length < 1 && !loadingPros) {
      return (
        <tr>
          <td className="no-data-wrap">No data available yet!</td>
        </tr>
      );
    } else {
      const hostRows = updatedHostsOnce?.map((updatedhost, index) => {
        return <ProHostAlllist key={`${updatedhost.id}-${index}`} hostDetails={updatedhost} />;
      });

      return hostRows;
    }
  };

  return (
    <>
      <PurebrandToast
        show={showToast}
        onClose={handleCloseToast}
        title={!failed ? "Success" : <p className="h4 text-danger"> Failed </p>}
        message={
          !failed
            ? "Media email will be sent in your email soon."
            : "Media email sending failed."
        }
      />
      <div>
        <div className="d-flex justify-content-end">
          <div className="search-wrapper col-md-4 col-sm-5 mb-3">
            <Formik
              initialValues={{ searchterm: "" }}
              onSubmit={(value) => {
                setLoadingPros(true);
                setHasMore(true);
                let res = updateHostRequestsOnce(
                  `?order=true&search=${value.searchterm}`
                );
                res.then(() => setLoadingPros(false));
              }}
            >
              {({ setFieldValue, values }) => (
                <Form>
                  <div className="row">
                    <div className="col-12 d-flex">
                      <Field
                        type="search"
                        placeholder="Search"
                        className="form-control"
                        onChange={(e) => {
                          setSearchTerminologyAll(e.target.value);
                          setFieldValue("searchterm", e.target.value);
                        }}
                        value={values.searchterm}
                        name="searchterm"
                      />
                      <button type="submit" className="search magnifier">
                        <Search />
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      <div id="allHostsScrollableDiv" style={{ height: '600px', overflow: 'auto' }}>
      <InfiniteScroll
        dataLength={updatedHostsOnce?.length || 0}
        next={fetchMoreData}
        hasMore={hasMore}
        loader={
          loadingPros && updatedHostsOnce?.length > 0 && (
            <div className="d-flex justify-content-center py-3">
              <Spinner animation="grow" />
              <Spinner animation="grow" />
              <Spinner animation="grow" />
            </div>
          )
        }
        scrollableTarget="allHostsScrollableDiv"
        endMessage={
          <div className="text-center py-3 text-muted">
            {!hasMore && updatedHostsOnce?.length > 0 && "You have seen all hosts!"}
          </div>
        }
      >
        <Table className="table-store" responsive>
          <thead>
            <tr>
              <th scope="col">
                <div className="arrows">Real Customer </div>
              </th>
              <th>Email</th>
              <th>Media</th>
              <th>Video meetings</th>
              <th>Earnings</th>
              <th>Social</th>
            </tr>
          </thead>
          <tbody>{gethostsAll()}</tbody>
        </Table>
      </InfiniteScroll>
      </div>
        {/* Show loading spinner for initial load */}
        {loadingPros && (!updatedHostsOnce || updatedHostsOnce.length === 0) && (
          <div className="d-flex justify-content-center py-4">
            <Spinner animation="grow" />
            <Spinner animation="grow" />
            <Spinner animation="grow" />
          </div>
        )}
      </div>
    </>
  );
};

export default HostsProSoftList